<template>
    <div class="web-tabs-list-page">
        <AppBreadCrumb :paths="[{ title: $t('webTabsPage.breadcrumbTitle') }]" />

        <div class="page-header p-2">
            <h2>{{ $t("webTabsPage.listPageTitle") }}</h2>
            <a-button type="primary" @click="$router.push('/integrations/webtabs/new')">
                <span class="material-icons">add</span>
                {{ $t("webTabsPage.buttonNew") }}
            </a-button>
        </div>

        <a-card :loading="loading" class="p-2">
            <a-table
                :columns="columns"
                :data-source="webTabs"
                :row-key="(record) => record._id"
                :pagination="{ pageSize: 10 }"
            >
                <template slot="icon" slot-scope="text, record">
                    <span class="material-icons" :style="{ color: record.iconColor || '#6b727d' }">
                        {{ record.icon }}
                    </span>
                </template>

                <template slot="name" slot-scope="text, record">
                    <div>
                        <div style="font-weight: 500">{{ record.name }}</div>
                        <div style="font-size: 12px; color: #999">{{ record.description }}</div>
                    </div>
                </template>

                <template slot="type" slot-scope="text">
                    <a-tag v-if="text === 'url'" color="blue">URL</a-tag>
                    <a-tag v-else-if="text === 'app'" color="purple">App</a-tag>
                </template>

                <template slot="placement" slot-scope="text">
                    <a-tag v-if="text === 'menu'" color="green">
                        <span class="material-icons tag-icon">menu</span>
                        Ana Menü
                    </a-tag>
                    <a-tag v-else-if="text === 'toolbar'" color="blue">
                        <span class="material-icons tag-icon">web_asset</span>
                        Toolbar
                    </a-tag>
                    <a-tag v-else-if="text === 'contact-widget'" color="orange">
                        <span class="material-icons tag-icon">contact_page</span>
                        Chat Widget
                    </a-tag>
                    <a-tag v-else-if="text === 'visitor-detail'" color="purple">
                        <span class="material-icons tag-icon">person_search</span>
                        Kişi Detay
                    </a-tag>
                    <a-tag v-else-if="text === 'app-switcher'" color="pink">
                        <span class="material-icons tag-icon">apps</span>
                        App Switcher
                    </a-tag>
                    <a-tag v-else-if="text === 'table-record-tab'" color="cyan">
                        <span class="material-icons tag-icon">table_view</span>
                        Tablo Kayıt Sekmesi
                    </a-tag>
                    <a-tag v-else-if="text === 'task-detail-tab'" color="volcano">
                        <span class="material-icons tag-icon">task_alt</span>
                        Görev Detay Sekmesi
                    </a-tag>
                    <a-tag v-else color="green">
                        <span class="material-icons tag-icon">menu</span>
                        Ana Menü
                    </a-tag>
                </template>

                <template slot="visibility" slot-scope="text, record">
                    <div
                        v-if="
                            !record.visibility ||
                            ((!record.visibility.users || record.visibility.users.length === 0) &&
                                (!record.visibility.departments || record.visibility.departments.length === 0))
                        "
                    >
                        <a-tag color="green">Herkese Açık</a-tag>
                    </div>
                    <div v-else>
                        <a-tag v-if="record.visibility.users && record.visibility.users.length > 0">
                            {{ record.visibility.users.length }} Kullanıcı
                        </a-tag>
                        <a-tag v-if="record.visibility.departments && record.visibility.departments.length > 0">
                            {{ record.visibility.departments.length }} Departman
                        </a-tag>
                    </div>
                </template>

                <template slot="enabled" slot-scope="text, record">
                    <a-switch :checked="record.enabled" @change="(checked) => toggleEnabled(record, checked)" />
                </template>

                <template slot="actions" slot-scope="text, record">
                    <a-space>
                        <a-tooltip title="Klonla">
                            <a-button
                                type="link"
                                size="small"
                                @click="cloneWebTab(record)"
                            >
                                <span class="material-icons">content_copy</span>
                            </a-button>
                        </a-tooltip>
                        <a-tooltip title="Düzenle">
                            <a-button
                                type="link"
                                size="small"
                                @click="$router.push(`/integrations/webtabs/${record._id}/edit`)"
                            >
                                <span class="material-icons">edit</span>
                            </a-button>
                        </a-tooltip>
                        <a-tooltip title="Sil">
                            <a-button type="link" size="small" danger @click="confirmDelete(record)">
                                <span class="material-icons">delete</span>
                            </a-button>
                        </a-tooltip>
                    </a-space>
                </template>
            </a-table>
        </a-card>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import AppBreadCrumb from "../../../components/common/AppBreadCrumb.vue";

export default {
    name: "WebTabsList",
    components: {
        AppBreadCrumb,
    },
    data() {
        return {
            loading: false,
            columns: [
                {
                    title: "İkon",
                    dataIndex: "icon",
                    key: "icon",
                    width: 80,
                    scopedSlots: { customRender: "icon" },
                },
                {
                    title: "Ad",
                    dataIndex: "name",
                    key: "name",
                    scopedSlots: { customRender: "name" },
                },
                {
                    title: "Tür",
                    dataIndex: "type",
                    key: "type",
                    width: 80,
                    scopedSlots: { customRender: "type" },
                },
                {
                    title: "Yerleşim",
                    dataIndex: "placement",
                    key: "placement",
                    width: 140,
                    scopedSlots: { customRender: "placement" },
                },
                {
                    title: "Görünürlük",
                    dataIndex: "visibility",
                    key: "visibility",
                    width: 200,
                    scopedSlots: { customRender: "visibility" },
                },
                {
                    title: "Sıra",
                    dataIndex: "order",
                    key: "order",
                    width: 80,
                },
                {
                    title: "Durum",
                    dataIndex: "enabled",
                    key: "enabled",
                    width: 100,
                    scopedSlots: { customRender: "enabled" },
                },
                {
                    title: "İşlemler",
                    key: "actions",
                    width: 120,
                    scopedSlots: { customRender: "actions" },
                },
            ],
        };
    },
    computed: {
        ...mapState({
            webTabs: (state) => state.webtabs.webTabs,
        }),
    },
    methods: {
        ...mapActions({
            fetchWebTabs: "webtabs/fetchWebTabs",
            updateWebTab: "webtabs/updateWebTab",
            deleteWebTab: "webtabs/deleteWebTab",
        }),
        async loadWebTabs() {
            this.loading = true;
            try {
                await this.fetchWebTabs();
            } catch (error) {
                this.$message.error("Web sekmeleri yüklenirken bir hata oluştu");
                console.error(error);
            } finally {
                this.loading = false;
            }
        },
        async toggleEnabled(record, checked) {
            try {
                await this.updateWebTab({
                    id: record._id,
                    data: {
                        ...record,
                        enabled: checked,
                    },
                });
                this.$message.success("Durum güncellendi");
            } catch (error) {
                this.$message.error("Durum güncellenirken bir hata oluştu");
                console.error(error);
            }
        },
        cloneWebTab(record) {
            this.$router.push({
                path: "/integrations/webtabs/new",
                query: { cloneFrom: record._id },
            });
        },
        confirmDelete(record) {
            const self = this;
            this.$confirm({
                title: "Web sekmesini silmek istediğinize emin misiniz?",
                content: `"${record.name}" adlı web sekmesi silinecek.`,
                okText: "Sil",
                okType: "danger",
                cancelText: "İptal",
                async onOk() {
                    try {
                        await self.deleteWebTab(record._id);
                        self.$message.success("Web sekmesi silindi");
                    } catch (error) {
                        self.$message.error("Web sekmesi silinirken bir hata oluştu");
                        console.error(error);
                    }
                },
            });
        },
    },
    mounted() {
        this.loadWebTabs();
    },
};
</script>

<style lang="scss" scoped>
.web-tabs-list-page {
    .page-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;

        h2 {
            margin: 0;
        }

        .material-icons {
            font-size: 18px;
            margin-right: 4px;
            vertical-align: middle;
        }
    }

    .material-icons {
        font-size: 24px;
        vertical-align: middle;
    }

    .tag-icon {
        font-size: 14px !important;
        margin-right: 4px;
        vertical-align: -3px;
    }
}
</style>
